import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  return (
    <React.Fragment>
      {/* Add a class to the body or a wrapper to style header differently on inner pages */}
      <div className="inner-page-wrapper">
        <Header variant="light" />

        <div className="contact-page">
          <Helmet>
            <title>Contact Us - Panmitra Online Services</title>
            <meta
              name="description"
              content="Get in touch with Panmitra for PAN card services, recharge, bill payments, API integration, or partnership inquiries. We're here to help!"
            />
          </Helmet>
        </div>

        {/*===== HERO AREA STARTS =======*/}
        <div
          className="about-header-area"
          style={{
            backgroundImage: "url(assets/img/bg/inner-header.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto">
                <div className="about-inner-header heading9 text-center">
                  <h1>Contact Us</h1>
                  <a href="/">
                    Home <i className="fa-solid fa-angle-right" />{" "}
                    <span>Contact Us</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*===== HERO AREA ENDS =======*/}

        {/*===== CONTACT AREA STARTS =======*/}
        <div className="contact-main-inner-area sp1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="heading2 contact-header">
                  <h5>Get in Touch</h5>
                  <h2>We're Here to Help You!</h2>
                  <p>
                    Whether you want to offer our services as an agent, or are
                    looking for API integration for your business, our team is
                    ready to assist you. Reach out to us via phone, email, or
                    visit our office.
                  </p>
                  <div className="space32" />
                  <div className="number-address-area">
                    <div className="phone-number">
                      <div className="img1">
                        <img src="assets/img/icons/phone3.svg" alt="Phone" />
                      </div>
                      <div className="content">
                        <p>Phone Number</p>
                        <a href="tel:+919632456111">+91 9632-456-111</a>
                      </div>
                    </div>
                    <div className="phone-number m-0">
                      <div className="img1">
                        <img src="assets/img/icons/email3.svg" alt="Email" />
                      </div>
                      <div className="content">
                        <p>Email Address</p>
                        <a href="mailto:panmitra121@gmail.com">
                          panmitra121@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="space50" />
                  <div className="number-address-area2">
                    <div className="phone-number">
                      <div className="img1">
                        <img
                          src="assets/img/icons/location3.svg"
                          alt="Location"
                        />
                      </div>
                      <div className="content">
                        <a href="#">
                          PANMITRA ONLINE SERVICE PRIVATE LIMITED, <br />
                          Belagavi, Karnataka - 590015, India
                        </a>
                      </div>
                    </div>
                    {/* <div className="phone-number">
                      <a
                        href="https://maps.app.goo.gl/your-office-link" //
                        className="map"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View on Map
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-1" />
              <div className="col-lg-5">
                <div className="contact-form-area">
                  <h4>Send Us a Message</h4>
                  <form action="#" method="POST">
                    {/* Replace with your actual Web3Forms access key */}
                    <input
                      type="hidden"
                      name="access_key"
                      value="YOUR_ACCESS_KEY_HERE"
                    />
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="input-area">
                          <input
                            type="text"
                            name="name"
                            placeholder="Your Full Name"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-area">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-area">
                          <input
                            type="tel"
                            name="phone"
                            placeholder="Phone Number"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-area">
                          <textarea
                            name="message"
                            placeholder="Your Message"
                            rows="4"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="input-area">
                          <button type="submit" className="header-btn1">
                            Send Message
                            <span>
                              <i className="fa-solid fa-arrow-right" />
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*===== LOCATION (SINGLE OFFICE) =====*/}
        <div className="location-section-area sp2 bg2">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 m-auto">
                <div className="location-header text-center heading2">
                  <h5>Our Office</h5>
                  <h2>Visit Our Headquarters</h2>
                </div>
              </div>
            </div>
            <div className="space60 d-lg-block d-none" />
            <div className="space30 d-lg-none d-block" />
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6">
                <div className="location-boxes">
                  <div className="img1">
                    <img src="assets/img/icons/location3.svg" alt="" />
                  </div>
                  <div className="space32" />
                  <a href="#">
                    Belagavi Main Office <br />
                    PANMITRA ONLINE SERVICE PRIVATE LIMITED
                  </a>
                  <div className="space24" />
                  <p>Phone Number</p>
                  <a href="tel:+919632456111">+91 9632-456-111</a>
                  <div className="space32" />
                  {/* <a
                    href="https://maps.app.goo.gl/your-office-link"
                    className="map"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View on Google Maps
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*===== MAP =====*/}
        <div className="mapouter">
          <div className="gmap_canvas">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15375.943571748428!2d74.490202!3d15.849815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbf0c9b3b9b9b9b%3A0x9b9b9b9b9b9b9b9b!2sBelagavi%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" // Replace with actual embed link
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Panmitra Office Location"
            />
          </div>
        </div>
        {/*===== CONTACT AREA ENDS =======*/}
      </div>

      <Footer />
    </React.Fragment>
  );
};

export default ContactUs;
